import { compile } from 'path-to-regexp';
import pathTypes from 'config/types/path';
import {
  defaultLanguage,
  languageCodePostTypeMap,
} from 'config/types/language';
import contentTypes from './';

/**
 * Custom content item path compilers.
 */
const compilePathMap = {
  [contentTypes.PAGE](pathMap, { slug, metadata: { type } }) {
    const compilePath = compile(pathMap[pathTypes.PAGE]);
    const language = Object.keys(languageCodePostTypeMap)
      .filter((abbr) => languageCodePostTypeMap[abbr].includes(type));
    return compilePath({
      slug,
      language: language[0] || defaultLanguage,
    });
  },
};

export default compilePathMap;
